export default __webpack_public_path__ + "static/media/gaia-text.82bd371d.png";